import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-eoi-exhibition-file-viewer',
  templateUrl: './eoi-exhibition-file-viewer.component.html',
  styleUrls: ['./eoi-exhibition-file-viewer.component.css']
})
export class EoiExhibitionFileViewerComponent implements OnInit {

  @Input() fileUrl!: string;
  sanitizedUrl!: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {
    this.fileUrl = data.fullUrl;
  }

  ngOnInit(): void {

    if (this.data.type === 'pdf') {
      this.loadPdf();
    } else {
      this.sanitizedUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
    }
  }

  loadPdf() {
    this.http.get(this.fileUrl, { responseType: 'blob' })
      .subscribe(blob => {
        const fileURL = URL.createObjectURL(blob);
        this.sanitizedUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      });
  }
}
